import { all } from "redux-saga/effects";
import { setTieuChuanSaga } from "./setTieuChuanSaga";
import { setTieuChuanHocSinhSaga } from "./setTieuChuanHocSinhSaga";
import { setTieuChuanSanPhamSaga } from "./setTieuChuanSanPhamSaga";

export default function* setTieuChuanSagaWrapper() {
    yield all([
        setTieuChuanSaga(),
        setTieuChuanSanPhamSaga(),
        setTieuChuanHocSinhSaga()
    ]);
}